import Controller from '@ember/controller';
import { service } from '@ember/service';
import { alias } from 'macro-decorators';

export default class DesksGetStartedController extends Controller {
  @service state;
  @alias('state.desksSubscription') desksSubscription;
}
